import React from 'react';
import { Box, Toolbar } from '@mui/material';
import ModernSidebar from './ModernSidebar';

const MainLayout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: 'background.default' }}>
      <ModernSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // Keep padding comfortable and under 30px across sizes
          p: { xs: 2, sm: 3 },
          width: '100%',
          // Drawer overlays content on all sizes; no left margin offset
          minHeight: '100vh',
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
